//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {

	name: "latte-widget-base",

	props: {

		data: {required: true, type: Object},
		id: {required: true, type: Object},
		drawBehindHeader: {default: false, type: Boolean}

	},

	mounted()
	{
		this.$emit("ready", {id: this.id, data: this.data});
	},

	methods: {

		setData(data)
		{
			let dashboard = this;

			while ((dashboard = dashboard.$parent) !== undefined)
				if (dashboard.$options.name === "latte-dashboard")
					break;

			dashboard.setWidgetData(this.id, Object.assign(this.data, data));
		}

	},

	watch: {

		data()
		{
			this.$emit("ready", {id: this.id, data: this.data});
		},

		id()
		{
			this.$emit("ready", {id: this.id, data: this.data});
		}

	}

}

